/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);
export function slider() {
    const tabsNavSelector = ".tabs-component__nav-container.swiper";
    const quoteSelector = ".quote-slider__quotes-container.swiper";
    const historySelector = ".history-slider__container.swiper";

    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a");
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Updates the mobile nav image to match the active slide's background
    const updateHistoryNavImage = function (swiper) {
        const navImage = document.querySelector('#' + swiper.el.dataset.componentId + " .history-slider__nav-image");
        if (!navImage) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        const bgMobile = activeSlide?.dataset.bgMobile;

        navImage.style.backgroundImage = bgMobile ? `url('${bgMobile}')` : '';
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        const tabNavSliders = [];
        const tabNavSlidersElements = document.querySelectorAll(tabsNavSelector);

        if (tabNavSlidersElements.length) {
            tabNavSlidersElements.forEach(sliderEl => {

                const componentRoot = sliderEl.closest(".tabs-component");
                const navButtons = Array.from(
                    componentRoot.querySelectorAll(".tabs-component__nav-item button")
                );
                const nextBtn = componentRoot.querySelector(".swiper-button-next");
                const prevBtn = componentRoot.querySelector(".swiper-button-prev");
                const maxIndex = navButtons.length - 1;

                let activeTabIndex = 0;

                const activateTab = (index) => {
                    activeTabIndex = index;
                    const btn = navButtons[index];
                    if (btn) btn.click();

                    swiper.slideTo(index);

                    updateDisabledClasses();
                };

                const updateDisabledClasses = () => {
                    if (prevBtn) {
                        if (activeTabIndex === 0) {
                            prevBtn.classList.add("is-disabled");
                        } else {
                            prevBtn.classList.remove("is-disabled");
                        }
                    }

                    if (nextBtn) {
                        if (activeTabIndex === maxIndex) {
                            nextBtn.classList.add("is-disabled");
                        } else {
                            nextBtn.classList.remove("is-disabled");
                        }
                    }
                };


                navButtons.forEach((btn, i) => {
                    btn.addEventListener("click", () => {
                        activateTab(i);
                    });
                });

                const swiper = new Swiper(sliderEl, {
                    speed: 500,
                    watchOverflow: true,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 15,
                        }
                    },
                    navigation: {
                        nextEl: "#" + sliderEl.dataset.componentId + " .swiper-button-next",
                        prevEl: "#" + sliderEl.dataset.componentId + " .swiper-button-prev",
                    },

                    on: {
                        slideChange: (sw) => {
                            handleSlideChange();
                            if (!sw.isBeginning && !sw.isEnd) {
                                const index = sw.realIndex;
                                activateTab(index);
                            }
                        },

                        slideChangeTransitionEnd: (sw) => {
                            handleSlideChangeTransitionEnd(sw);
                        }
                    }
                });

                tabNavSliders.push(swiper);

                nextBtn?.addEventListener("click", () => {
                    if (!swiper.isEnd) return;

                    if (activeTabIndex < maxIndex) {
                        activateTab(activeTabIndex + 1);
                    }
                });

                prevBtn?.addEventListener("click", () => {
                    if (!swiper.isBeginning) return;

                    if (activeTabIndex > 0) {
                        activateTab(activeTabIndex - 1);
                    }
                });
            });
        }

        //Quote sliders
        const quoteSliders = [];
        const quoteSlidersElements = document.querySelectorAll(quoteSelector);
        if (quoteSlidersElements) {
            quoteSlidersElements.forEach(slider => {
                quoteSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 1,
                    loop: true,
                    spaceBetween: 30,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .pagination",
                        clickable: true,
                        dynamicBullets: true,
                    },
                    breakpoints: {
                        992: {
                            pagination: {
                                dynamicBullets: false,
                            }
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .swiper-button-next",
                        prevEl: '#' + slider.dataset.componentId + " .swiper-button-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        //History sliders
        const historySliders = [];
        const historySlidersElements = document.querySelectorAll(historySelector);
        if (historySlidersElements) {
            historySlidersElements.forEach(slider => {
                historySliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 1,
                    loop: true,
                    spaceBetween: 30,
                    breakpoints: {
                        992: {
                            pagination: {
                                el: ".history-slider__inner .pagination.desktop",
                                dynamicBullets: false,
                            },
                        }
                    },
                    pagination: {
                        el: ".history-slider__inner .pagination.mobile",
                        clickable: true,
                        dynamicBullets: true,
                        renderBullet: function (index, className) {
                            const getSlideTag = (index) => {
                                const slide = Array.from(slider.querySelectorAll('.swiper-slide')).find(
                                    (el) => el.getAttribute('data-swiper-slide-index') == index
                                );
                                return slide ? slide.getAttribute("data-pagination") : `Slide ${index + 1}`;
                            };
                            const tag = getSlideTag(index);
                            return `<span class="${className}">${tag}</span>`;
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .swiper-button-next",
                        prevEl: '#' + slider.dataset.componentId + " .swiper-button-prev",
                    },
                    on: {
                        init: (sw) => {
                            updateHistoryNavImage(sw);
                        },
                        slideChange: (sw) => {
                            handleSlideChange();
                            updateHistoryNavImage(sw);
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
